(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventView.Attendees",
                    {
                        url: "/Attendees",
                        component: "attendees",
                        PageTitle: "Event Responders | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("attendees",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventView/Attendees/attendees-template.html",
                controller: attendeesController
            });

    attendeesController.$inject = ["$stateParams", "marketingTrackerEventGroupApi", "$mdDialog", "figToaster", "_", "$scope", "$rootScope", "$filter", "marketingTrackerActOnApi", "marketingTrackerRMEApi", "featureToggleService", "amplitudeService", "moment", "rmeCampaignStartDate"];
    function attendeesController($stateParams, marketingTrackerEventGroupApi, $mdDialog, figToaster, _, $scope, $rootScope, $filter, marketingTrackerActOnApi, marketingTrackerRMEApi, featureToggleService, amplitudeService, moment, rmeCampaignStartDate) {

        const $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                isLoading: true,
                isUploading: false,
                showRmeApiSection: false
            },
            deleteList: deleteList,
            uploadList: uploadList,
            importListFromRmeApi: importListFromRmeApi,
            toggleSort: toggleSort,
            searchFilterText: "",
            exportSegmentToActOn: exportSegmentToActOn,
            filterByResponderInsight: filterByResponderInsight,
            getRmeApiCampaigns: getRmeApiCampaigns

        });

        $ctrl.resultsPerPageOptions = [
            { id: 1, count: 25 },
            { id: 2, count: 50 },
            { id: 3, count: 100 }
        ];

        $ctrl.responderStatuses = [
            {
                Id: 0,
                Name: 'All',
                Filter: function () {
                    return true;
                }
            },
            {
                Id: 1,
                Name: 'Reserved',
                Filter: function (responder) {
                    return filterByResponderStatus(responder, 'Reserved');
                }
            },
            {
                Id: 2,
                Name: 'Opted-Out',
                Filter: function (responder) {
                    return filterByResponderStatus(responder, 'Opted-Out');
                }
            },
            {
                Id: 3,
                Name: 'Cancelled',
                Filter: function (responder) {
                    return filterByResponderStatus(responder, 'Cancelled');
                }
            },
            {
                Id: 4,
                Name: 'Un-Registered',
                Filter: function (responder) {
                    return filterByResponderStatus(responder, 'Un-Registered');
                }
            }
        ];

        $ctrl.attendanceStatuses = [
            {
                Id: 0,
                Name: 'All',
                Filter: function () {
                    return true;
                }
            },
            {
                Id: 1,
                Name: 'Attended',
                Filter: function (responder) {
                    return filterByAttendanceStatus(responder, true);
                }
            },
            {
                Id: 2,
                Name: 'Did Not Attend',
                Filter: function (responder) {
                    return filterByAttendanceStatus(responder, false);
                }
            }
        ];

        $ctrl.chartOptions = {
            cutoutPercentage: 75,
            legend: {
                display: true,
                position: 'right',
                labels: {
                    boxWidth: 24,
                    padding: 20
                }
            },
            elements: {
                arc: {
                    borderWidth: 0
                }
            }
        };

        $ctrl.responderInsight = {
            ReservedCount: {
                Status: 'Reserved',
                Amount: 0,
                Type: 'Responder'
            },
            OptedOutCount: {
                Status: 'Opted Out',
                Amount: 0,
                Type: 'Responder'
            },
            CancelledCount: {
                Status: 'Canceled',
                Amount: 0,
                Type: 'Responder'
            },
            UnregisteredCount: {
                Status: 'Un-registered',
                Amount: 0,
                Type: 'Responder'
            },
            AttendedCount: {
                Status: 'Attended',
                Amount: 0,
                Type: 'Attendance'
            },
            DidNotAttendCount: {
                Status: 'Did Not Attend',
                Amount: 0,
                Type: 'Attendance'
            },
            RespondersCount: {
                Name: 'Responders',
                Amount: 0,
                Type: 'AttendedType'
            },
            GuestsCount: {
                Name: 'Guest',
                Amount: 0,
                Type: 'AttendedType'
            }
        };

        $ctrl.responderInsightArray = Object.values($ctrl.responderInsight);

        $ctrl.chartColors = ['#6E6BC4', '#AED5FE', '#FAAF18', '#C95DAC'];

        $scope.$on('chart-create', function (event, instance) {
            // used to obtain chart instance
            $scope.chart = instance.chart;
        });

        $scope.responderStatusFilter = function (elements, e) {
            // helper function that translates an event to a position in canvas coordinates
            var pos = Chart.helpers.getRelativePosition(e, $scope.chart);

            // inRange is the function on the chart element that is used for hit testing
            var intersect = elements.find(function (element) {
                return element.inRange(pos.x, pos.y);
            });
            if (intersect) {
                $ctrl.selectedResponderStatus = $ctrl.responderStatuses[intersect._index + 1];
                //Added to update table view
                $rootScope.$apply();
            }
        };

        $scope.attendanceStatusFilter = function (elements, e) {
            var pos = Chart.helpers.getRelativePosition(e, $scope.chart);

            var intersect = elements.find(function (element) {
                return element.inRange(pos.x, pos.y);
            });
            if (intersect) {
                $ctrl.selectedAttendanceStatus = $ctrl.attendanceStatuses[intersect._index + 1];
                $rootScope.$apply();
            }
        };

        function uploadList(file) {
            $ctrl.ui.isUploading = true;
            var payload = new FormData();
            payload.append("responders", file);

            var message = "", toastClass = "";
            marketingTrackerEventGroupApi.postEventResponders($ctrl.EventGroupId, $ctrl.EventId, payload)
                .then(loadListView)
                .then(function () {
                    $ctrl.uploadDate = new Date();
                    message = $ctrl.responderList.EventResponders.length + " responders added.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    message = "Error: " + error.data;
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.isUploading = false;
                    amplitudeService.logClickEvent('Upload RME Responder List from PC');
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function getRmeApiCampaigns() {

            marketingTrackerRMEApi.getCustomerCampaigns()
                .then(function (response) {
                    console.log(response)
                    $ctrl.ui.showRmeApiSection = true;
                    $ctrl.rmeCampaignsFromApi = response;

                    console.log($ctrl.ui.showRmeApiSection)
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                });
        }

        function importListFromRmeApi(rmeCampaignId) {
            $ctrl.ui.isUploading = true;
            var message = "", toastClass = "";
            marketingTrackerEventGroupApi.postEventRespondersFromRmeApi($ctrl.EventGroupId, $ctrl.EventId, rmeCampaignId, moment().set(rmeCampaignStartDate).format(), moment().format())
                .then(loadListView)
                .then(function (response) {
                    $ctrl.uploadDate = new Date();
                    message = $ctrl.responderList.EventResponders.length + " responders added.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem importing your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    if ($ctrl.orderedList) {
                        setPage(1);
                    }
                    $ctrl.ui.isUploading = false;
                    amplitudeService.logClickEvent('Import Responder List from RME API');
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function loadListView(responderList) {
            $ctrl.responderList = responderList;
            _.forEach(Object.keys(responderList),
                function (item) {
                    if ($ctrl.responderInsight[item]) {
                        $ctrl.responderInsight[item].Amount = responderList[item];
                    }
                });
            $ctrl.responderInsightArray = Object.values($ctrl.responderInsight);
            return responderList;
        }

        function deleteList($event) {
            var message = "", toastClass = "";

            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this attendee list? This action is permanent.",
                targetEvent: $event,
                ariaLabel: "Confirm list removal",
                ok: "Delete List",
                cancel: "Cancel",
                multiple: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm)
                .then(function () {
                    marketingTrackerEventGroupApi.deleteEventResponders($ctrl.EventGroupId, $ctrl.EventId);
                    message = $ctrl.responderList.EventResponders.length + " responders removed.";
                    toastClass = "is-success";
                    $ctrl.responderList = null;
                    $ctrl.uploadDate = null;
                    clearListView();
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem updating your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.isUploading = false;
                    $ctrl.ui.isLoading = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function clearListView() {
            _.forEach($ctrl.responderInsight,
                function (item) {
                    item.Amount = 0;
                });
            $ctrl.responderInsightArray = Object.values($ctrl.responderInsight);
        }

        function filterByResponderInsight(index) {
            if (responder.Type === 'Responder') {
                $ctrl.selectedResponderStatus = $ctrl.responderStatuses[index + 1];
            } else {
                $ctrl.selectedAttendanceStatus = $ctrl.attendanceStatuses[index + 1];
            }

        }

        function filterByResponderStatus(responder, status) {
            var responderStatus = responder.Status;
            return responderStatus === status;
        }

        function filterByAttendanceStatus(responder, status) {
            var attendanceStatus = responder.Attended;
            return attendanceStatus === status;
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function exportSegmentToActOn($event) {
            return marketingTrackerActOnApi.getActonLists()
                .then(function (response) {
                    $mdDialog.show({
                        templateUrl: "App/Tools/MarketingTrackerNew/Events/EventView/Attendees/AddToActOn/add-to-act-on-template.html",
                        controller: "addToActOnController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        resolve: {
                            responderStatuses: function () {
                                return $ctrl.responderStatuses;
                            },
                            attendanceStatuses: function () {
                                return $ctrl.attendanceStatuses;
                            },
                            selectedResponderStatus: function () {
                                return $ctrl.selectedResponderStatus;
                            },
                            selectedAttendanceStatus: function () {
                                return $ctrl.selectedAttendanceStatus;
                            },
                            filteredList: function () {
                                var filterChain = $filter('filter')($ctrl.responderList.EventResponders, $ctrl.selectedResponderStatus.Filter);
                                var filterChainTwo = $filter('filter')(filterChain, $ctrl.searchFilterText);
                                var filteredList = $filter('filter')(filterChainTwo, $ctrl.selectedAttendanceStatus.Filter);
                                return filteredList;
                            },
                            actOnLists: function () {
                                return response;
                            }
                        },
                        bindToController: true
                    });
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem exporting your data. Please try again shortly.";
                    toastClass = "is-error";
                    return figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    amplitudeService.logClickEvent('Act-On Export');
                });

        }

        $ctrl.$onInit = function () {
            $ctrl.toggleFeature = featureToggleService.checkEnv();
            $ctrl.propertyName = 'FirstName';
            $ctrl.reverseOrder = false;
            $ctrl.resultsPerPage = $ctrl.resultsPerPageOptions[0];
            $ctrl.selectedResponderStatus = $ctrl.responderStatuses[0];
            $ctrl.selectedAttendanceStatus = $ctrl.attendanceStatuses[0];
            $ctrl.EventGroupId = $stateParams.EventGroupId;
            $ctrl.EventId = $stateParams.EventId;
            $ctrl.getRmeApiCampaigns();
            marketingTrackerEventGroupApi.getEventResponders($ctrl.EventGroupId, $ctrl.EventId)
                .then(function (response) {
                    if (response.status) {
                        return;
                    }
                    loadListView(response);
                    $ctrl.uploadDate = new Date(response.UploadTime);
                })
                .finally(function () {
                    $ctrl.ui.isLoading = false;
                });
        };
    }

})(window.app, window.angular); //jshint ignore:line